import { render } from "./CardRenderEffectBoxComponent.vue?vue&type=template&id=3d4caf70&ts=true"
import script from "./CardRenderEffectBoxComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderEffectBoxComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__